import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/9079dcfc2575f0838408e044c89ac09.png';
const _withScopeId = n => (_pushScopeId("data-v-974d4f9e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 0,
  style: {
    "float": "left",
    "background-color": "#304156",
    "display": "flex"
  }
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "68",
  height: "57"
})], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1",
    "color": "aquamarine",
    "align-items": "center",
    "line-height": "57px"
  }
}, [/*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("h1", {
  style: {
    "font-family": "cursive",
    "font-size": "18px"
  }
}, "敖东销售")])], -1));
const _hoisted_5 = [_hoisted_3, _hoisted_4];
const _hoisted_6 = ["index"];
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 0,
  style: {
    "height": "60px",
    "background-color": "#304156",
    "display": "flex"
  }
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": ""
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "68",
  height: "60"
})], -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1",
    "color": "aquamarine",
    "align-items": "center",
    "line-height": "60px"
  }
}, [/*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("h1", {
  style: {
    "font-family": "cursive",
    "font-size": "18px"
  }
}, "敖东销售")])], -1));
const _hoisted_11 = [_hoisted_9, _hoisted_10];
const _hoisted_12 = {
  key: 2
};
const _hoisted_13 = {
  key: 3
};
const _hoisted_14 = ["index"];
const _hoisted_15 = {
  key: 2
};
const _hoisted_16 = {
  key: 3
};
const _hoisted_17 = {
  key: 2
};
const _hoisted_18 = {
  key: 3
};
const _hoisted_19 = {
  key: 2
};
const _hoisted_20 = {
  key: 3
};
import { getMenuList } from '@/api/loginApi';
import { computed, onMounted, ref, watch } from 'vue';
import store from '@/store';
import { useRoute } from 'vue-router';
import router, { constantRoutes } from '@/router';
import { stringToBooleans } from '@/utils/stringToBoolean';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const yuyan = ref(false);
    const topsty = ref();
    const activeIndex2 = ref('1');
    const handleSelect = (key, keyPath) => {
      console.log(key, keyPath);
      if (key === '/') {
        router.replace(keyPath[0]);
      } else {
        router.replace(keyPath[1]);
      }
    };
    const route = useRoute();
    onMounted(() => {
      console.log('我创建了');
      qiehuanZhEn(localStorage.getItem('lang') || 'zh');
      // document.querySelector('ul')?.setAttribute('style', 'width:calc(100% - 19px)')
    });

    const iconList = ref(['user', 'setting', 'shop', 'tickets', 'pie-chart', 'tickets']);
    const icon = ref('menu');
    const defaultActive = ref(sessionStorage.getItem('path') || '/users');
    const menusList = ref([]);
    // 获取菜单数据
    // 静态路由
    // console.log(constantRoutes)
    const initMenusList = async () => {
      const resl = constantRoutes.filter(item => {
        return item.meta.show === true;
      });
      const res = await getMenuList();
      menusList.value = res.data.filter(item => {
        return item.meta.title !== '大屏展示';
      });
      menusList.value.push(...resl);
      // console.log(menusList.value)
    };
    // 监听汉堡按钮的变化
    const siderType = computed(() => {
      return store.getters.siderType;
    });
    // 监听左边菜单logo
    const sidebarLogoType = computed(() => {
      if (store.getters.sidebarLogoType === undefined) {
        return stringToBooleans(localStorage.getItem('sidebarLogo') || '');
      } else {
        return store.getters.sidebarLogoType;
      }
    });
    // 监听菜单模式
    const menuType = computed(() => {
      if (store.getters.moshiNum === undefined) {
        return localStorage.getItem('changeMoshi') || 1;
      } else {
        return store.getters.moshiNum;
      }
    });
    // 初始化菜单
    initMenusList();
    // 保存点击路径
    const savePath = path => {
      sessionStorage.setItem('path', `${path}`);
    };
    // 监听标签路由的变化改变默认激活路由
    watch(() => route.path, () => {
      defaultActive.value = route.path;
    });
    // 监听中英文切换
    watch(() => store.getters.lang, () => {
      console.log(store.getters.lang);
      qiehuanZhEn(store.getters.lang);
    });
    function qiehuanZhEn(val) {
      if (val === 'en') {
        yuyan.value = true;
      } else {
        yuyan.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_setting = _resolveComponent("setting");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      return _unref(menuType) === '2' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_unref(sidebarLogoType) ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5)) : _createCommentVNode("", true), _createVNode(_component_el_menu, {
        style: _normalizeStyle([topsty.value, {
          "display": "flex",
          "overflow": "auto"
        }]),
        ellipsis: "true",
        "default-active": activeIndex2.value,
        class: "el-menu-demo",
        mode: "horizontal",
        "background-color": "#545c64",
        "text-color": "#fff",
        "active-text-color": "#ffd04b",
        onSelect: handleSelect
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          index: "/"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_setting)]),
            _: 1
          }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('menus.home')), 1)]),
          _: 1
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menusList.value, item => {
          return _openBlock(), _createBlock(_component_el_sub_menu, {
            key: item.id,
            index: item.path + ''
          }, {
            title: _withCtx(() => [item.meta.icon.slice(0, 3) !== 'my-' ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 0
            }, {
              default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.meta.icon)))]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), item.meta.icon.slice(0, 3) === 'my-' ? (_openBlock(), _createBlock(_component_svg_icon, {
              key: 1,
              icon: item.meta.icon
            }, null, 8, ["icon"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(item.meta.title), 1)]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, it => {
              return _openBlock(), _createElementBlock("div", {
                index: item.path + '/' + it.path,
                key: it.id
              }, [it.component == null ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                key: 0,
                mode: "horizontal"
              }, {
                title: _withCtx(() => [item.meta.icon.slice(0, 3) !== 'my-' ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0
                }, {
                  default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(icon.value)))]),
                  _: 1
                })) : _createCommentVNode("", true), item.meta.icon.slice(0, 3) === 'my-' ? (_openBlock(), _createBlock(_component_svg_icon, {
                  key: 1,
                  icon: item.meta.icon
                }, null, 8, ["icon"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(it.meta.title), 1)]),
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(it.children, itchi => {
                  return _openBlock(), _createBlock(_component_el_menu_item, {
                    index: it.path + '/' + itchi.path,
                    key: itchi.id,
                    onClick: $event => savePath(it.path + '/' + itchi.path)
                  }, {
                    default: _withCtx(() => [item.meta.icon.slice(0, 3) !== 'my-' ? (_openBlock(), _createBlock(_component_el_icon, {
                      key: 0
                    }, {
                      default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(itchi.meta.icon)))]),
                      _: 2
                    }, 1024)) : _createCommentVNode("", true), item.meta.icon.slice(0, 3) === 'my-' ? (_openBlock(), _createBlock(_component_svg_icon, {
                      key: 1,
                      icon: item.meta.icon
                    }, null, 8, ["icon"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(itchi.meta.title), 1)]),
                    _: 2
                  }, 1032, ["index", "onClick"]);
                }), 128))]),
                _: 2
              }, 1024)) : (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 1,
                index: item.path + '/' + it.path,
                onClick: $event => savePath(item.path + '/' + it.path)
              }, {
                default: _withCtx(() => [item.meta.icon.slice(0, 3) !== 'my-' ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0
                }, {
                  default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(it.meta.icon)))]),
                  _: 2
                }, 1024)) : _createCommentVNode("", true), item.meta.icon.slice(0, 3) === 'my-' ? (_openBlock(), _createBlock(_component_svg_icon, {
                  key: 1,
                  icon: item.meta.icon
                }, null, 8, ["icon"])) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(it.meta.title), 1)]),
                _: 2
              }, 1032, ["index", "onClick"]))], 8, _hoisted_6);
            }), 128))]),
            _: 2
          }, 1032, ["index"]);
        }), 128))]),
        _: 1
      }, 8, ["style", "default-active"])])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_unref(sidebarLogoType) ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11)) : _createCommentVNode("", true), _createVNode(_component_el_menu, {
        "active-text-color": "#ffd04b",
        "background-color": "#304156",
        class: "el-menu-vertical-demo",
        "default-active": defaultActive.value,
        "text-color": "#fff",
        router: "",
        "unique-opened": "",
        collapse: !_unref(siderType)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
          index: "/"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_setting)]),
            _: 1
          }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('menus.home')), 1)]),
          _: 1
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menusList.value, item => {
          return _openBlock(), _createBlock(_component_el_sub_menu, {
            key: item.id,
            index: item.path + ''
          }, {
            title: _withCtx(() => [item.meta.icon.slice(0, 3) !== 'my-' ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 0
            }, {
              default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.meta.icon)))]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), item.meta.icon.slice(0, 3) === 'my-' ? (_openBlock(), _createBlock(_component_svg_icon, {
              key: 1,
              icon: item.meta.icon
            }, null, 8, ["icon"])) : _createCommentVNode("", true), yuyan.value ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.meta.enTitle), 1)) : _createCommentVNode("", true), !yuyan.value ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.meta.title), 1)) : _createCommentVNode("", true)]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, it => {
              return _openBlock(), _createElementBlock("div", {
                index: item.path + '/' + it.path,
                key: it.id
              }, [it.component == null ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                key: 0,
                mode: "horizontal"
              }, {
                title: _withCtx(() => [item.meta.icon.slice(0, 3) !== 'my-' ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0
                }, {
                  default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(icon.value)))]),
                  _: 1
                })) : _createCommentVNode("", true), item.meta.icon.slice(0, 3) === 'my-' ? (_openBlock(), _createBlock(_component_svg_icon, {
                  key: 1,
                  icon: item.meta.icon
                }, null, 8, ["icon"])) : _createCommentVNode("", true), yuyan.value ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(it.meta.enTitle), 1)) : _createCommentVNode("", true), !yuyan.value ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(it.meta.title), 1)) : _createCommentVNode("", true)]),
                default: _withCtx(() => [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(it.children, itchi => {
                  return _openBlock(), _createBlock(_component_el_menu_item, {
                    index: it.path + '/' + itchi.path,
                    key: itchi.id,
                    onClick: $event => savePath(it.path + '/' + itchi.path)
                  }, {
                    default: _withCtx(() => [item.meta.icon.slice(0, 3) !== 'my-' ? (_openBlock(), _createBlock(_component_el_icon, {
                      key: 0
                    }, {
                      default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(itchi.meta.icon)))]),
                      _: 2
                    }, 1024)) : _createCommentVNode("", true), item.meta.icon.slice(0, 3) === 'my-' ? (_openBlock(), _createBlock(_component_svg_icon, {
                      key: 1,
                      icon: item.meta.icon
                    }, null, 8, ["icon"])) : _createCommentVNode("", true), yuyan.value ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(itchi.meta.enTitle), 1)) : _createCommentVNode("", true), !yuyan.value ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(itchi.meta.title), 1)) : _createCommentVNode("", true)]),
                    _: 2
                  }, 1032, ["index", "onClick"]);
                }), 128))])]),
                _: 2
              }, 1024)) : (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 1,
                index: item.path + '/' + it.path,
                onClick: $event => savePath(item.path + '/' + it.path)
              }, {
                default: _withCtx(() => [item.meta.icon.slice(0, 3) !== 'my-' ? (_openBlock(), _createBlock(_component_el_icon, {
                  key: 0
                }, {
                  default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(it.meta.icon)))]),
                  _: 2
                }, 1024)) : _createCommentVNode("", true), item.meta.icon.slice(0, 3) === 'my-' ? (_openBlock(), _createBlock(_component_svg_icon, {
                  key: 1,
                  icon: item.meta.icon
                }, null, 8, ["icon"])) : _createCommentVNode("", true), yuyan.value ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(it.meta.enTitle), 1)) : _createCommentVNode("", true), !yuyan.value ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(it.meta.title), 1)) : _createCommentVNode("", true)]),
                _: 2
              }, 1032, ["index", "onClick"]))], 8, _hoisted_14);
            }), 128))]),
            _: 2
          }, 1032, ["index"]);
        }), 128))]),
        _: 1
      }, 8, ["default-active", "collapse"])]));
    };
  }
});